import React, { useEffect, useState } from 'react'
import DataTableLayer from "../../components/DataTableLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PostByAgg from '../../utils/axios';
import ReleaseApprovalForm from './ReleaseApprovalForm';
import Modal from "../../components/Modal";
import ModalAlert from '../../components/ModalAlert';
import LottieLoading from '../../components/child/LottieLoading';






const ReleaseApproval = () => {

    const {roleCode} = useAuth()
    const [dataRelease,setDataRelease] = useState([]);
    const [openModal,setOpenModal] = useState(false)
    const [openModalView,setOpenModalView] = useState(false)
    const [openModalApproval,setOpenModalApproval] = useState(false)
    const [selectedRow,setSelectedRow] = useState()
    const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: 10,
            totalRecords: 0,
            totalPages: 0,
        });

    const [modalOpen, setModalOpen] = useState(<div></div>)
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [description, setDescription] = useState('');
    const [selectedRowApproval,setSelectedRowApproval] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const {email} = useAuth()
    const columns = [
  
        {
          header: "Music Label Name",
          accessorKey: "music_label_name",
        },
        {
            header:"Judul Release",
            accessorKey:"title",
        },
        {
          header: "Genre",
          accessorKey: "genre_name",
        },
        {
            header:"SubGenre",
            accessorKey:"sub_genre_name"
        },
        {
            accessorKey: "status_name",
            header: "Status",
            cell: ({ row }) => {
            const status = row.getValue("status_name");
                let badgeColor;
            switch (status) {
                case "WAITING":
                badgeColor = "bg-warning";
                break;
                case "LIVE":
                badgeColor = "bg-danger";
                break;
                default:
                badgeColor = "bg-success";
                break;
            }
            if (status === "ACTIVE") {
                return (
                  <span className={`badge ${badgeColor}`}>{status}</span>
                );
              } else {
                return (
                  <span onClick={() => {}} className={`badge ${badgeColor}`}>{status}</span>
                );
              }
            },
        },
        {
            header:"Release Channel",
            accessorKey:"release_channels",
            cell: ({ row }) => {
                const releaseChannels = row.original.release_channels;
                // Pastikan releaseChannels tidak null atau undefined sebelum menggunakan map
                if (Array.isArray(releaseChannels)) {
                  // Mengambil nama-nama channel dan menggabungkannya menjadi string
                  const channelNames = releaseChannels.map(channel => channel.channel_name).join(", ");
                  return <span className='badge bg-primary m-1'>{channelNames}</span>;
                } else {
                  return <span>No Channels Available</span>; // Tampilkan pesan jika data release_channels tidak ada
                }
              }
        },
        {
            header:"release Date",
            accessorKey:"release_date",
            cell: ({ row }) => {
                // Format tanggal pada kolom release_date
                const formattedDate = formatDate(row.original.release_date);
                return <span>{formattedDate}</span>;
            }
            
        },
...(roleCode !== 'RL2411065833191'
    ? [
        {
          id: 'action',
          header:"Action",
          accessorKey:"action",
          cell: ({ row }) => (
            roleCode === 'RL2411062373407' && (
                <div className="dropdown">
                    <button
                        className="btn px-18 py-11 text-primary-light"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <Icon
                            icon="ph:dots-three-outline-fill"
                            className="menu-icon"
                        />
                    </button>
                    <ul className="dropdown-menu"
                    >
                        {/* <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={() => handleAction('edit', row)}
                            >
                                Edit
                            </Link>
                        </li> */}
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={() => handleAction('view', row)}
                            >
                                View
                            </Link>
                        </li>
                        {/* <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={()=> handleAction('delete', row)}
                            >
                                Delete
                            </Link>
                        </li> */}
                    </ul>
                </div>
            )
          ),
        }
        ]
      : []),
    ];

    const listStatus = [
        {
            value: "ST2411082239045",
            label: "WAITING"
        },
        {
            value: "ST2505220666504",
            label: "LIVE"
        }
       
    ]
    // aktif tidak ada reason , reject dan onProggress ada reason ,

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        let year = date.getFullYear();

        if (year === 1) {
            year = 1000;
        }

        return `${day}-${month}-${year}`;
    }

    const GetReleaseApproval = () => {
        setIsLoading(true)
        const url = 'song/v1/release/list'
        PostByAgg({
            url:url,
            body:
                {
                    "page" : pagination.pageIndex + 1, 
                    "page_size" : pagination.totalRecords,
                    "keyword" : ""
                },
            onResponse:onResponseReleaseApproval,
            onError: onErrorReleaseApproval
        })
    };

    useEffect(() => {
      GetReleaseApproval()
    }, [pagination.pageIndex, pagination.pageSize])

    function onResponseReleaseApproval(response) {
        console.log("response Release Approval",response.data.data)
        if(response.data.data){
            const totalRecords = response.data.data.total_records;
            const totalPages = Math.ceil(totalRecords / pagination.pageSize);
            setPagination((prev) => ({
                ...prev,
                totalRecords: totalRecords,
                totalPages: totalPages,
                pageSize: totalRecords,
                // pageIndex: 0,
                }));
                setIsLoading(false)
            setDataRelease(response.data.data.data)
        }else{
            setIsLoading(false)
            setDataRelease([])
        }
    }

    function onErrorReleaseApproval(error) {
        console.log("Error Release Approval",error.response)
        setModalOpen(
            <ModalAlert
             show={true}
             type={"failed"}
             text={error.response.data}
             action={() => {}}
             />
        )
    }

    const handleCreate = () =>{
        setOpenModal(true)
      }

    const handleAction = (action, row) => {
        console.log("action",action)
       if(action === 'edit'){
          setSelectedRow(row.original);  // Set selectedRow with actual data
          setOpenModal(true);
        }
        else if (action === 'view') {
          setSelectedRow(row);  // Set selectedRow with actual data
          setOpenModalView(true);
        } else if (action === 'delete') {
            // Your delete logic here
            console.log("Delete Row:", row);
        }
      }

      const handleCloseModalView = () => {
        setOpenModalView(false);
        setSelectedRow('');
        GetReleaseApproval();
      }

      const handleApproval = (row) => {
        if (row && row.original) {
            console.log("Approval")
            console.log("ROW: ", row)
            setSelectedRowApproval(row.original);
            setOpenModalApproval(true);
            setDescription('');
        } else {
            console.error("Invalid row data", row);
        }
  
      }

      const handleCloseModalApproval = () => {
        setOpenModalApproval(false);
        setSelectedStatus(null);
        setSelectedRowApproval('');
        setDescription('');
      }

      const handleSubmitApproval = () => {
        console.log("dor")
        const url = 'song/v1/release/update-status'
        PostByAgg({
            url: url,
            body:{
                "music_label_code":selectedRowApproval.music_label_code,
                "release_code":selectedRowApproval.release_code,
                "release_status_code":selectedStatus,
                "reason":description,
                "updated_by":email
            },
            onResponse: onResponseStatusApproval,
            onError: onErrorStatusApproval,
        })
      }

      const onResponseStatusApproval = (response) => {
        console.log("status Approval Response",response.data)
        if(response.data.code === "2002000"){
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    type={"success"}
                    message={`Approval ` + response.data.message.id}
                    action={() => {
                        setShowSuccessModal(false);
                        handleCloseModalApproval();
                        GetReleaseApproval();
                    }}
                />
            )
        }
      }
      
      const onErrorStatusApproval = (error) => {
        console.log("status Approval Error",error)
        setShowSuccessModal(
            <ModalAlert
                show={true}
                type= {'failed'}
                message={error.response.data.message.id}
                action={() => {
                    handleCloseModalApproval();
                    GetReleaseApproval();
                }}
            />
        )
      } 

      const handleDownload = () => {
        const headers = columns.map(col => col.header).filter(Boolean);
        const rows = dataRelease.map(row => {
          return columns.map(col => {
            const key = col.accessorKey;
            return row[key] !== undefined ? row[key] : '';
          });
        });
      
        const csvContent = [
          headers.join(','),
          ...rows.map(row => row.join(','))
        ].join('\n');
      
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `release_approval_page_${pagination.pageIndex + 1}.csv`);
        link.click();
      };

  return (
    <div>
        
         <DataTableLayer
                data={dataRelease}
                columns={columns}
                title={"Release List Approval"}
                btnTitle={"Download Report"}
                showButton={true}
                pagination={pagination}
                handleAction={handleAction}
                onClick={handleDownload}
              />
              {
                openModalView && (
                    <ReleaseApprovalForm
                        data={selectedRow}
                        open={openModalView}
                        mode="view"
                        onClose={handleCloseModalView}
                        onSubmit={()=>{}}
                    />
                )
              }
              {
                openModalApproval && (
                    <Modal
                      open={openModalApproval}
                      onClose={handleCloseModalApproval}
                      title={selectedRowApproval.music_label_name}
                      Submit={handleSubmitApproval}
                    >
                        <div className="mb-3">
                            <label className="col-form-label" htmlFor="status">Status :</label>
                            <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} >
                                <option>Pilih </option>
                                {listStatus.map((status, index) => {
                                    if (status.label !== selectedRowApproval.status_name) { 
                                        return (
                                            <option key={index} value={status.value}>
                                                {status.label}
                                            </option>
                                        );
                                    }
                                    return null;
                                })}
                            </select>
                           
                            {
                                selectedStatus === "ST2411115202158" ? (
                                <div className="mb-3">
                                    {/* <label className="col-form-label" htmlFor="isActive">Is Active :</label>
                                    <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedActive(JSON.parse(e.target.value))} >
                                        <option>Pilih </option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select> */}
                                </div>
                                ):(
                                selectedStatus != null && (
                                <div className="mb-3">
                                    <label htmlFor="message-text" className="col-form-label">Message:</label>
                                    <textarea className="form-control" id="message-text" defaultValue={description} onChange={(e) => setDescription(e.target.value)} cols={"30"} rows={"5"}></textarea>
                                </div>
                                )
                                )
                            }
                        </div>
                    </Modal>
             )}
             {isLoading && <LottieLoading text='Loading...'/>}
        {modalOpen}
        {showSuccessModal}
        
    </div>
  )
}

export default ReleaseApproval